export default __webpack_public_path__ + "static/media/twitter.9ff24a09.svg";